import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { NotifcationModel } from "../models/notification.models";
import { Socket } from "ngx-socketio2";
import { BehaviorSubject } from "rxjs";
import { tap } from "rxjs/operators";
import { EventService } from "./event.service";

@Injectable({
  providedIn: "root",
})
export class NotificationService extends Socket {
  public notifications$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(
    []
  );
  private eventSourceCalendar!: EventSource;
  private eventSourceMediationAgreement!: EventSource;
  private eventSourceLeadAssignment!: EventSource;

  constructor(private http: HttpClient, private eventService: EventService) {
    super({
      url: `${environment.notificationUrl}`,
      options: {
        withCredentials: true,
        autoConnect: false,
        path: `${environment.notifictionPath}`,
      },
    });
  }

  getAll() {
    return this.http.get<any>(`${environment.apiUrl}/notifications/read`, {
      withCredentials: true,
    });
  }

  getMessages() {
    return this.http.get<any>(`${environment.apiUrl}/notifications/messages`, {
      withCredentials: true,
    });
  }

  updateToRead(id: any) {
    return this.http.patch<any>(
      `${environment.apiUrl}/notifications/read/${id}`,
      { read: true },
      { withCredentials: true }
    );
  }

  updateAllToRead() {
    return this.http.patch<any>(
      `${environment.apiUrl}/notifications/read`,
      {},
      { withCredentials: true }
    );
  }

  receiveNotifyLeads() {
    return this.on<any>("receive_notify_leads").pipe(
      tap((args: any) => {
        console.log("receive_notify_leads: ", args);
      })
    );
  }

  notifyLeads(data: any) {
    this.emit("notify_leads", data);
  }

  receiveNotifyProperties() {
    return this.on<any>("receive_notify_properties").pipe(
      tap((args: any) => {
        console.log("receive_notify_properties: ", args);
      }),
    );
  }

  notifyProperties(data: any) {
    this.emit("notify_properties", data);
  }

  receiveNotifictionsImagesProcessed() {
    return this.on<any>("receive_notifications_images_processed").pipe(
      tap((args: any) => {
        console.log("receive_notifications_images_processed: ", args);
      })
    );
  }

  receiveNotifictionsUnitsProcessed() {
    return this.on<any>("receive_notifications_units_processed").pipe(
      tap((args: any) => {
        console.log("receive_notifications_units_processed: ", args);
      })
    );
  }

  receiveNotifictionsImagesProgress() {
    return this.on<any>("receive_notifications_images_progress").pipe(
      tap((args: any) => {
        console.log("receive_notifications_images_progress: ", args);
      })
    );
  }

  chatDisconnect() {
    return this.on("disconnect").pipe(
      tap((args: any) => {
        console.log("disconnect: ", args);

        if (this.eventSourceCalendar?.readyState === 1) {
          this.eventSourceCalendar.close();
        }
      })
    );
  }

  notifyCalendarEvents() {
    // this.eventSourceCalendar = new EventSource(`${environment.apiUrl}/notifications/calendar-events`, { withCredentials: true });
    if (this.eventSourceCalendar?.readyState === 0) {
      this.eventSourceCalendar.onmessage = ({ data }) => {
        this.eventService.broadcast(
          "push-notifications-calendar-events",
          JSON.parse(data)
        );
      };
      this.eventSourceCalendar.onerror = () => {
        if (this.eventSourceCalendar?.readyState === 2) {
          this.eventSourceCalendar.close();
        }
        if (this.connected && this.eventSourceCalendar?.readyState === 1) {
          this.notifyCalendarEvents();
        }
      };
    }
  }

  notifyeventSourceMediationAgreement() {
    // this.eventSourceCalendar = new EventSource(`${environment.apiUrl}/notifications/calendar-events`, { withCredentials: true });
    if (this.eventSourceMediationAgreement?.readyState === 0) {
      this.eventSourceMediationAgreement.onmessage = ({ data }) => {
        console.log("New message mediation agreement", JSON.parse(data));
        this.eventService.broadcast(
          "push-notifications-mediation-agreement",
          JSON.parse(data)
        );
      };
      this.eventSourceMediationAgreement.onerror = () => {
        if (this.eventSourceMediationAgreement?.readyState === 2) {
          this.eventSourceMediationAgreement.close();
        }
        if (
          this.connected &&
          this.eventSourceMediationAgreement?.readyState === 1
        ) {
          this.notifyeventSourceMediationAgreement();
        }
      };
    }
  }

  notifyeventSourceLeadAssignment() {
    // this.eventSourceCalendar = new EventSource(`${environment.apiUrl}/notifications/calendar-events`, { withCredentials: true });
    if (this.eventSourceLeadAssignment?.readyState === 0) {
      this.eventSourceLeadAssignment.onmessage = ({ data }) => {
        console.log("New message lead assignment", JSON.parse(data));
        this.eventService.broadcast(
          "push-notifications-lead-assignment",
          JSON.parse(data)
        );
      };
      this.eventSourceLeadAssignment.onerror = () => {
        if (this.eventSourceLeadAssignment?.readyState === 2) {
          this.eventSourceLeadAssignment.close();
        }
        if (
          this.connected &&
          this.eventSourceLeadAssignment?.readyState === 1
        ) {
          this.notifyeventSourceLeadAssignment();
        }
      };
    }
  }

  connectedNotification() {
    // this.connect();

    if (environment.production) {
      this.connect();
      setTimeout(() => {
        if (
          !this.eventSourceCalendar ||
          this.eventSourceCalendar?.readyState === 2
        ) {
          this.eventSourceCalendar = new EventSource(
            `${environment.notificationUrl}/real-time/notifications/calendar-events`,
            { withCredentials: true }
          );
          this.notifyCalendarEvents();
        }

        if (
          !this.eventSourceMediationAgreement ||
          this.eventSourceMediationAgreement?.readyState === 2
        ) {
          this.eventSourceMediationAgreement = new EventSource(
            `${environment.notificationUrl}/real-time/notifications/mediation-agreement`,
            { withCredentials: true }
          );
          this.notifyeventSourceMediationAgreement();
        }

        if (
          !this.eventSourceLeadAssignment ||
          this.eventSourceLeadAssignment?.readyState === 2
        ) {
          this.eventSourceLeadAssignment = new EventSource(
            `${environment.notificationUrl}/real-time/notifications/lead-assignment`,
            { withCredentials: true }
          );
          this.notifyeventSourceLeadAssignment();
        }
      }, 1000 * 60);
    }
  }

  disconnectNotification() {
    this.disconnect();
    if (this.eventSourceCalendar?.readyState === 1) {
      this.eventSourceCalendar.close();
    }

    if (this.eventSourceMediationAgreement?.readyState === 1) {
      this.eventSourceMediationAgreement.close();
    }
    if (this.eventSourceLeadAssignment?.readyState === 1) {
      this.eventSourceLeadAssignment.close();
    }
  }
}
